import React, { Component } from 'react';

import Loading from '../../common/loading';
import { Page, PageHeader, Card, SearchInput, DataList, TextButton, FlushButtons, Country, matchSearch } from '../../common/ui';
import { API_PREFERENCES, COUNTRY_VATS } from '../../config';
import ModalCountry from '../../common/modal/modalCountry';
import { randomString } from '../../common/actions/randomString';
import { returnNationality } from '../../common/actions/returnNationality';
import { controlRole } from '../../common/actions/controlRole';
import { isEmpty, withNavigate } from '../../utility';
import axiosInstance from '../../axiosInstance';

class whitelist extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // contiene la lista dei country con le relative IVA, restituita dopo la chiamata al BE
            getCountryList: {},

            // contiene la lista dei country senza sigla con le relative IVA (Esempio: IT diventa Italia, e cosi via)
            countryListSanitized: {},

            // array contenente degli oggetti, ogni oggetto ha una nazione e la relativa IVA
            newCountryList: [],

            hasClickEdit: false,

            // nazione di riferimento nel caso si volesse editare o rimuovere
            nationReference: '',

            // iva di riferimento nel caso si volesse editare o rimuovere
            ivaReference: '',

            // descrizione per il campo iva
            romanianDescription: '',

            shortId: randomString(),

            modal: false,
            isLoading: false,
            loadingForRole: true,

            // testo di ricerca nella lista
            search: ''
        }
        this.setLoading = this.setLoading.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    /**
     * Il mount e l'update sono uguali, poiche se navigo tra i link di react router, dopo aver
     * caricato questa pagina, esegue solo il mount, mentre se refresho la pagina carica l'update.
     * 
     * (Esempio: se vado una prima volta sulla pagina utenti, dopo il mount carica update.
     * Se dopo il caricamento, senza refreshare, navigo e vado ad altre parti, esempio player, e poi ritorno,
     * react carica solo il mount e nemmeno una volta update.)
     */
    componentDidMount() {
        // se l'utente non ha nessun permesso per visualizzare country vats, viene rispedito alla home
        if (!isEmpty(this.props.role.preferences)) {
            if (!controlRole(this.props.role.preferences, "api/Preferences", "GET")) {
                this.props.handleNavigation(this.props.navigate, `/`);
                this.props.infoNotify('Non hai nessun permesso per visualizzare country vats!')
            } else {
                if (this.state.loadingForRole) {
                    this.setState({ loadingForRole: false });
                    this.getCountryList();
                }
            }
        }
    }

    componentDidUpdate() {
        // se l'utente non ha nessun permesso per visualizzare country vats, viene rispedito alla home
        if (!isEmpty(this.props.role.preferences)) {
            if (!controlRole(this.props.role.preferences, "api/Preferences", "GET")) {
                this.props.handleNavigation(this.props.navigate, `/`);
                this.props.infoNotify('Non hai nessun permesso per visualizzare country vats!')
            } else {
                if (this.state.loadingForRole) {
                    this.setState({ loadingForRole: false });
                    this.getCountryList();
                }
            }
        }

        if (!localStorage.token) {
            this.props.handleNavigation(this.props.navigate, '/');
        }
    }

    setLoading = (value) => {
        this.setState({ isLoading: value });
    }

    /**
     * Usato solo per chiudere la modale, poiche resetta tutto lo state
     */
    toggleModal = () => {
        this.setState(prevState => ({ modal: !prevState.modal }));
        this.setState({
            hasClickEdit: false,
            nationReference: '',
            ivaReference: '',
            romanianDescription: '',
            keyNation: '',
            shortId: randomString()
        });
    }

    /**
     * Chiama il BE e ritorna la lista degli indirizzi della whitelist
     * 
     * @return type array
     */
    getCountryList = async () => {
        this.setState({ isLoading: true });
        try {
            let response = await axiosInstance.get(`${API_PREFERENCES}/${COUNTRY_VATS}`);
            this.setState({
                getCountryList: response.data,
                isLoading: false
            });
        } catch (result) {
            const { errorNotify } = this.props;
            this.setState({ isLoading: false });
            if (result && result.response && result.response.status) {
                switch (result.response) {
                    default: errorNotify(`Error ${result.response.status} su ${API_PREFERENCES} - GET`); break;
                }
            }
        }
    }

    /**
     * Se viene cliccato il pulsante edit, attiva la modale per inviare la nazione da editatare
     * @param nation è la nazione che deve essere modificata (è la sigla della nazione)
     * @param iva è il nuovo valore dell'iva che deve essere cambiato
     * 
     */
    hasClickEdit = (nation, iva, description) => {
        this.setState({
            hasClickEdit: true,
            nationReference: nation,
            ivaReference: iva,
            romanianDescription: description
        });
        setTimeout(() => {
            this.setState(prevState => ({ modal: !prevState.modal }));
        }, 1000);
    }

    /**
     * Invio la modifica della lista dei country
     */
    sendEditCountryList = (id, data) => {
        this.props.sendEditPreferences(id, data);
        this.toggleModal();
        setTimeout(() => {
            this.getCountryList();
        }, 1000);
    }

    render() {
        const { getCountryList, search } = this.state;
        const { role } = this.props;

        const canEdit = controlRole(role.preferences, "api/Preferences", "PUT");
        const countries = Object.keys(getCountryList)
            .filter(code => matchSearch(search, code, returnNationality(code)))
            .map(code => ({ code, ...getCountryList[code] }));

        return (
            <Page>
                <PageHeader
                    title="IVA per paese"
                    subtitle={`${Object.keys(getCountryList).length} paesi`}
                    actions={
                        <FlushButtons
                            canFlush={controlRole(role.preferences, "api/Preferences/flush", "POST")}
                            canFlushConfig={controlRole(role.configFlush, "api/Config", "POST")}
                            onFlush={this.props.flush}
                            onFlushConfig={this.props.flushConfig}
                        />
                    }
                />

                {
                    (this.props.preferences.isLoading || this.state.isLoading || this.state.loadingForRole) ? <Loading /> :
                        <Card>
                            <div className="uiToolbar">
                                <SearchInput value={search} onChange={value => this.setState({ search: value })} placeholder="Cerca per paese o sigla" />
                                {search && <span className="uiCount">{countries.length} risultati</span>}
                            </div>

                            <DataList
                                columns={[
                                    { key: 'code', label: 'Paese', width: 'minmax(0, 2fr)', render: el => <Country code={el.code} showCode /> },
                                    { key: 'Vat', label: 'IVA', width: '110px', align: 'right', numeric: true, render: el => `${el.Vat}%` },
                                ]}
                                rows={countries}
                                rowKey={el => el.code}
                                empty={search ? 'Nessun paese trovato' : 'Nessun paese'}
                                actionsWidth="110px"
                                actions={
                                    canEdit ?
                                        el => <TextButton icon="far fa-edit" onClick={() => { this.hasClickEdit(el.code, el.Vat, el.RomanianDescription) }}>Modifica</TextButton>
                                        : undefined
                                }
                            />
                        </Card>
                }

                {
                    this.state.hasClickEdit &&
                    <ModalCountry
                        titleModal="Modifica Nazione"

                        clickEdit={this.sendEditCountryList}
                        toggle={this.toggleModal}

                        nationReference={this.state.nationReference}
                        ivaReference={this.state.ivaReference}
                        romanianDescription={this.state.romanianDescription}

                        stateModal={this.state.modal}
                        key={this.state.shortId}
                        errorNotify={this.props.errorNotify}
                    />
                }
            </Page>
        )
    }
}

export default withNavigate(whitelist);